<script>
import {mapGetters} from 'vuex'
export default
{
    name: 'mv-tracker-form',

    computed:
    {
        ...mapGetters({
            buses: 'buses',
        }),
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    created()
    {
        this.$store.dispatch('trackerBusesFetch')
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.UID') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.uid" disabled readonly>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('ARTIST.NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.comment">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('MENU.BUS') }}
            </label>
            <div class="col-md-6">
                <select class="form-control" v-model="model.bus_id">
                    <option value="">-</option>
                    <option v-for="bus in buses" :key="bus.id" :value="bus.id">
                        {{ bus.name }}
                    </option>
                </select>
            </div>
        </div>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/TrackerForm.vue